import React from 'react'
import './AboutHero.css'

export default function AboutHero() {
  return (
    <div className="AboutHero">
        <div className='AboutHeroCont'>
            <h1>Building Digital Solutions That Power Growth</h1>
            <p>
                RastegHub is a product-driven technology company committed to designing, developing, and maintaining
                digital solutions that help businesses and individuals innovate, scale, and succeed.
            </p>
        </div>
        {/* <div className='AboutHeroImages'>
            <img src="https://images.pexels.com/photos/574070/pexels-photo-574070.jpeg" alt="About Hero" className='AboutHeroImage'/>
        </div> */}
    </div>
  )
}
